module.exports = __webpack_public_path__ + "media/images/common/order_btn2_l_ov-f92375c4f399b70391d4658cb437b99e.png";